import React from "react";
import { SquareCheckbox } from "../../components/Inputs/SquareCheckbox/SquareCheckbox";

const SubscriptionDeviceRow = ({ device, checkChangedHandler }) => {

    const statusChanged = () => {
        checkChangedHandler(device.accountId);
    }
    return (
        <tr key={device.accountId}>
            <td className="d-flex justify-content-center">
                <SquareCheckbox
                    id={`deviceValidCheckbox${device.accountId}`}
                    value={device.autoRenew}
                    valueChangeHandler={statusChanged}
                    size="lg"
                    checkClassName="p-1"
                >
                </SquareCheckbox>
            </td>          
            <td className="text-center py-2">
                {device.deviceName}
            </td>
            <td className="text-center py-2">
                {device.locationName}
            </td>
            <td className="text-center py-2">
                {device.isActive && !device.autoRenew &&
                    <span className="text-warning">Expiring!</span>}
            </td>
        </tr>
    )

}

export default SubscriptionDeviceRow;